import React from "react";

export const CustomDishTitle: React.FC = () => {
  return (
    <h2 className="text-[16px] text-fontGray leading-[22px] font-normal text-center">
      Can’t find your favourite dish? <br /> Then simply add it below.
    </h2>
  );
};
